"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findTopLevelFunctions = exports.tokenizeJS = void 0;
const seeker_1 = require("../seeker");
const core_1 = require("../core");
const helpers_1 = require("../helpers");
function tokenizeJS(source) {
    return core_1.tokenize(source, {
        isDelimiter,
        isStringDelimiter: helpers_1.isStringDelimiter,
        isWhitespace: helpers_1.isWhitespace,
        shouldAddToken,
        createToken: helpers_1.createToken,
        getCommentStartType: helpers_1.getJSCommentStartType,
        isCommentEnd: helpers_1.isCommentEnd,
        getUnclosedComment: helpers_1.getUnclosedComment,
    });
}
exports.tokenizeJS = tokenizeJS;
const isDelimiter = (char) => char === ":" ||
    char === ";" ||
    char === "*" ||
    char === "/" ||
    char === "." ||
    char === "," ||
    char === "(" ||
    char === ")" ||
    char === "{" ||
    char === "}" ||
    char === ">" ||
    char === "=" ||
    char === "<" ||
    char === "|" ||
    char === "?" ||
    char === "[" ||
    char === "]" ||
    char === "+" ||
    char === "-" ||
    char === "~" ||
    char === "^" ||
    char === "&" ||
    char === "%" ||
    char === "!";
const shouldAddToken = (type) => helpers_1.isComment(type) || type === "space" ? false : true;
function findTopLevelFunctions(tokens) {
    const s = new seeker_1.Seeker(tokens);
    let t;
    const functions = [];
    while ((t = s.next())) {
        if (!t.type) {
            break;
        }
        if (t.value === "function") {
            let functionTokens = {
                init: t,
                name: undefined,
                generator: undefined,
                args: undefined,
                body: undefined,
                start: t.start,
                end: t.end,
            };
            t = s.peek();
            if (t.type === "*") {
                t = s.next();
                functionTokens.generator = t;
                t = s.peek();
            }
            if (t.type === "text") {
                t = s.next();
                functionTokens.name = t;
            }
            const args = getBlock(s, "(", ")");
            if (args) {
                functionTokens.args = args;
            }
            else {
                // error missing args
            }
            t = s.peek();
            if (t.type === "{") {
                functionTokens.body = getBlock(s, "{", "}");
            }
            else {
                // error no block
            }
            functionTokens.end = t.end;
            functions.push(functionTokens);
        }
    }
    return functions;
}
exports.findTopLevelFunctions = findTopLevelFunctions;
function getBlock(s, blockStart, blockEnd) {
    let t = s.next();
    if (t.type !== blockStart) {
        return;
    }
    let block = [t];
    let blockLevel = 1;
    while ((t = s.next())) {
        if (!t.type) {
            if (blockLevel !== 0) {
                // unclosed block
            }
            break;
        }
        block.push(t);
        if (t.type === blockEnd) {
            blockLevel--;
            if (blockLevel === 0) {
                break;
            }
        }
        else if (t.type === blockStart) {
            blockLevel++;
        }
    }
    return block;
}
//# sourceMappingURL=js-tokenizer.js.map